import { render, staticRenderFns } from "./LayerWidget.vue?vue&type=template&id=499481cb&scoped=true&"
import script from "./LayerWidget.vue?vue&type=script&lang=js&"
export * from "./LayerWidget.vue?vue&type=script&lang=js&"
import style0 from "./LayerWidget.vue?vue&type=style&index=0&id=499481cb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499481cb",
  null
  
)

export default component.exports